import React, { useState, useEffect } from 'react'
import '../styles/admin.css'
import PostProject from '../components/PostProject'
import EditProject from '../components/EditProject'
import PostReview from '../components/PostReview'
import EditReview from '../components/EditReview'
import axios from 'axios'



const Admin = () => {

    const API = process.env.REACT_APP_API_URL;

    const [mode, setMode] = useState(1);

    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [login, setLogin] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const selectMode = (m) => {
        setMode(m);
    }


    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API}/api/login`,
                { password },
                { withCredentials: true }
            );
            setMessage(response.data.message);

            if (response.status === 200) {
                const { token } = response.data;

                localStorage.setItem('authToken', token);


                setIsAuthenticated(true);
            }
        } catch (error) {
            setMessage(error.response?.data?.message || 'An error occurred');
        }
    };

    useEffect(() => {
        const verifyToken = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) return;

            try {
                const response = await axios.get(`${API}/api/auth/verify`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (response.status === 200) {
                    setIsAuthenticated(true);
                } else {
                    logout();
                }
            } catch (error) {
                console.error("Token verification failed:", error.response?.data || error.message);
                logout();
            }
        };

        verifyToken();
    }, []);


    const logout = () => {
        localStorage.removeItem("authToken");
        setIsAuthenticated(false);
        setLogin(false);
    };

    return (
        <div>
            {isAuthenticated ? (
                <div id='admin-main'>
                    <div id='admin-control'>
                        <button onClick={() => selectMode(1)} className={`admin-mode-btn ${mode === 1 ? 'admin-mode-btn-active' : ''}`}>Edit Project</button>
                        <button onClick={() => selectMode(2)} className={`admin-mode-btn ${mode === 2 ? 'admin-mode-btn-active' : ''}`}>Create Project</button>
                        <button onClick={() => selectMode(3)} className={`admin-mode-btn ${mode === 3 ? 'admin-mode-btn-active' : ''}`}>Edit Review</button>
                        <button onClick={() => selectMode(4)} className={`admin-mode-btn ${mode === 4 ? 'admin-mode-btn-active' : ''}`}>Create Review</button>


                    </div>
                    <div id='admin-form-bod'>
                        {mode === 1 ? (
                            <EditProject />
                        ) : mode === 2 ? (
                            <PostProject />
                        ) : mode === 3 ? (
                            <EditReview />
                        ) : (
                            <PostReview />
                        )}

                    </div>

                </div>
            ) : (

                <div id='login-main'>

                    <form id='login-form' onSubmit={handleLogin}>
                        <input className='admin-form-input' name='password' type='password' value={password}
                            onChange={(e) => setPassword(e.target.value)} placeholder='your password' />
                        <button className='admin-form-btn' type='submit'>Login</button>
                    </form>

                </div>

            )}

        </div>
    )
}

export default Admin